import { ReactNode } from "react";
import GridLayout from "./GridLayout/GridLayout";
import clsx from "clsx";

interface HeroProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  containerWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "full";
  backgroundStyle?: "gradient" | "plain" | "none";
  extraBottomPadding?: boolean;
  titleClassName?: string;
}

const containerWidths = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  full: "max-w-full",
};

export default function Hero({
  title,
  description,
  action,
  className = "",
  containerWidth = "full",
  backgroundStyle = "gradient",
  extraBottomPadding = false,
  titleClassName,
  ...props
}: HeroProps) {
  const backgroundClasses = {
    gradient:
      "bg-gradient-heading bg-[length:400%_400%] animate-bg-animation [animation-play-state:running]",
    plain: "bg-white dark:bg-gray-900",
    none: "",
  };

  return (
    <div
      className={`${backgroundClasses[backgroundStyle]} ${className}`}
      {...props}
    >
      <div className="bg-radial-heading">
        <div className="max-w-[1440px] mx-auto">
          <GridLayout
            gridCols="grid-cols-12"
            className={
              extraBottomPadding
                ? "pt-8 md:pt-12 lg:pt-20 pb-8 md:pb-48 lg:pb-48"
                : "py-8 md:py-12 lg:py-14"
            }
          >
            <div
              className={`col-span-12 sm:col-span-12 md:col-span-8 lg:col-span-8 ${containerWidths[containerWidth]}`}
            >
              <h1
                className={clsx(
                  "font-medium text-[4rem] md:text-[5rem] lg:text-[6rem] leading-[1.1] md:leading-[1.17] lg:leading-[1.13] mb-6 text-wrap break-words",
                  titleClassName,
                )}
              >
                {title}
              </h1>
              {description && (
                <div className="text-lg md:text-xl lg:text-2xl leading-[1.56] md:leading-[1.4] lg:leading-[1.33]">
                  {description}
                </div>
              )}
              {action && <div className="pt-6 md:pt-8 lg:pt-10">{action}</div>}
            </div>
          </GridLayout>
        </div>
      </div>
    </div>
  );
}
